import {
  InterestFilterDashboard_interestFilters as InterestFilter,
} from "types/gql-types";

const convertGroupToFilter = (group: string[], filters: InterestFilter[]): InterestFilter[] =>
  group
    .map((fieldName) => filters.find((flt) => flt.name === fieldName) || null)
    .filter((flt) => flt !== null) as InterestFilter[];

const groups = [
  ["heading_applicant_age", "applicant_dob", "applicant_dob_over_55"],
  ["heading_income", "household_income"],
  ["heading_position_number", "has_position_number", "position_number"],
  ["heading_household_size", "household_count"],
  [
    "heading_subsidy",
    "household_receives_other_housing_assistance",
    "household_has_housing_authority_voucher",
  ],
  [
    "heading_bedrooms",
    "unit_size_1br",
    "unit_size_1br_den",
    "unit_size_2br",
    "unit_size_3br",
    "unit_size_4br",
    "unit_size_5br",
    "unit_size_sro",
    "unit_size_studio",
    "unit_size_shared",
  ],
  [
    "heading_preferences",
    "applicant_rental_buy_pref",
    "household_all_full_time_students",
    "household_has_pets",
    "household_served_in_armed_forces",
    "household_requires_impairment_hearing",
    "household_requires_impairment_mobility",
    "household_requires_impairment_visual",
    "household_has_special_accommodations",
    "house_member_wheelchair",
  ],
  [
    "custom_pref_1",
    "custom_pref_1_inverse",
    "custom_pref_2",
    "custom_pref_2_inverse",
    "custom_pref_3",
    "custom_pref_3_inverse",
    "custom_pref_4",
    "custom_pref_4_inverse",
    "custom_pref_5",
    "custom_pref_5_inverse",
    "custom_pref_6",
    "custom_pref_6_inverse",
    "custom_pref_7",
    "custom_pref_7_inverse",
  ],
  [
    "custom_pref_8",
    "custom_pref_8_inverse",
    "custom_pref_9",
    "custom_pref_9_inverse",
    "custom_pref_10",
    "custom_pref_10_inverse",
    "custom_pref_11",
    "custom_pref_11_inverse",
    "custom_pref_12",
    "custom_pref_12_inverse",
    "custom_pref_13",
    "custom_pref_13_inverse",
    "custom_pref_14",
    "custom_pref_14_inverse",
  ],
  [
    "heading_gender",
    "household_member_0_gender",
  ],
];

/** returns a list of lists containing interest filters grouped by their category */
export const groupedInterestFilters = (filters: InterestFilter[]): InterestFilter[][] =>
  groups.map((group) => convertGroupToFilter(group, filters));
